<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" ref="modal" id="buscarProductoModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Agregar Producto</h4>
                        <button type="button" class="btn-close" @click="cerrarModal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row mt-3">
                            <label class="col-sm-3 col-form-label">Producto</label>
                            <div class="col-sm-7">
                                <select ref="select" class="form-control select2" v-model="selectedProducto">
                                    <option value="">Seleccionar Producto</option>
                                    <option v-for="producto in productosFiltrados" :key="producto.id"
                                        :value="producto.id">
                                        {{ producto.codigo }} - {{ producto.descripcion }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-1">
                                <div class="dropdown d-inline-block">
                                    <button ref="toggleFiltros" class="btn btn-info dropdown-toggle" type="button"
                                        id="ddlFiltros" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <i class="fas fa-filter"></i>
                                    </button>
                                    <div class="dropdown-menu p-3 dropdown-menu-right" aria-labelledby="ddlFiltros"
                                        style="min-width: 280px;" @click.stop>
                                        <div class="form-group">
                                            <label>Proveedor</label>
                                            <select class="form-control select2" v-model="selectedProveedor">
                                                <option value="">Todos los Proveedores</option>
                                                <option v-for="proveedor in proveedores" :key="proveedor.id"
                                                    :value="proveedor.id">
                                                    {{ proveedor.codigo }} - {{ proveedor.descripcion }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label>Categoria</label>
                                            <select class="form-control select2" v-model="selectedCategoria">
                                                <option value="">Todas las Categorías</option>
                                                <option v-for="categoria in categoriasFiltradas" :key="categoria.id"
                                                    :value="categoria.id">
                                                    {{ categoria.codigo }} - {{ categoria.descripcion }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="d-flex justify-content-between mt-2">
                                            <button class="btn btn-sm btn-outline-secondary" @click="limpiarFiltros()">
                                                Limpiar
                                            </button>
                                            <button class="btn btn-sm btn-primary" @click="$refs.toggleFiltros.click()">
                                                Cerrar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row mt-3">
                            <label class="col-sm-3 col-form-label">Presentacion</label>
                            <div class="col-sm-9">
                                <select class="form-control select2" v-model="selectedPresentacion">
                                    <option value="CAJA">CAJA / BULTO</option>
                                    <option value="UNIDAD">UNIDAD</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row mt-3">
                            <label class="col-sm-3 col-form-label">Cantidad</label>
                            <div class="col-sm-9">
                                <input min="1" class="form-control" type="number" v-model="selectedCantidad">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="limpiarFiltros">Limpiar</button>
                        <button type="button" class="btn btn-primary" @click="emitirSeleccion">Agregar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import api from "@/services/api";
import "select2";


export default {
    name: "AgregarProductoModal",
    data() {
        return {
            proveedores: [],
            categorias: [],
            productos: [],
            selectedProveedor: "",
            selectedCategoria: "",
            selectedProducto: "",
            selectedPresentacion: "CAJA",
            selectedCantidad: 1,
            observacion: ""
        };
    },
    computed: {
        cantidad() {
            if (!this.selectedProducto) return 0;
            const prod = this.productos.find(p => p.id == this.selectedProducto);
            if (!prod) return this.selectedCantidad;
            return this.selectedPresentacion === "CAJA"
                ? this.selectedCantidad * prod.cantxcaja
                : this.selectedCantidad;
        },
        categoriasFiltradas() {
            return this.selectedProveedor
                ? this.categorias.filter(c => c.proveedor_id == this.selectedProveedor)
                : this.categorias;
        },
        productosFiltrados() {
            const activos = this.productos.filter(p => p.estatus != 0);
            return this.selectedCategoria
                ? activos.filter(p => p.categoria_id == this.selectedCategoria)
                : this.selectedProveedor
                    ? activos.filter(p => this.categoriasFiltradas.some(c => c.id == p.categoria_id))
                    : activos;
        }
    },
    mounted() {
        this.$nextTick(() => {
            $(this.$refs.select).select2({
                theme: "bootstrap4",
                tags: true, // Permite escribir texto nuevo
                allowClear: true,
                placeholder: "Selecciona o escribe un producto",
                dropdownParent: $(this.$refs.modal)
            }).on("select2:select", (event) => {
                this.selectedProducto = event.params.data.id; // Captura correctamente el valor escrito
            });
        });
        this.modalInstance = new Modal(this.$refs.modal);
        this.cargarDatos();
    },
    methods: {
        abrirModal() {
            this.modalInstance.show();
        },
        cerrarModal() {
            this.selectedProveedor = "",
                this.selectedCategoria = "",
                this.selectedProducto = "",
                this.selectedPresentacion = "CAJA",
                this.selectedCantidad = 1,
                this.observacion = "",
                this.$nextTick(() => {
                    $(this.$refs.select).val(null).trigger('change.select2')
                }),
                this.modalInstance.hide();
        },
        async cargarDatos() {
            try {
                const [proveedoresRes, categoriasRes, productosRes] = await Promise.all([
                    api.get("/proveedor"),
                    api.get("/categoria"),
                    api.get("/producto"),
                ]);

                this.proveedores = proveedoresRes.data;
                this.categorias = categoriasRes.data;
                this.productos = productosRes.data;
            } catch (error) {
                console.error("Error cargando datos:", error);
            }
        },
        limpiarFiltros() {
            this.selectedProveedor = "";
            this.selectedCategoria = "";
            this.selectedProducto = "";
        },
        emitirSeleccion() {
            const productoSeleccionado = this.productos.find(p => p.id == this.selectedProducto);
            if (productoSeleccionado) {
                this.$emit("producto-seleccionado", productoSeleccionado, this.cantidad, this.observacion);
                this.cerrarModal();
            }
        }
    }
};
</script>

<style scoped>
.modal-body {
    max-height: 60vh;
    overflow-y: auto;
}
</style>